'use strict';

export default class EditableInput {

    constructor() {

        // Display related modal window when clicking on the input to edit
        $('.js-edit-input').on('click', function (e) {
            e.preventDefault();

            let $this = $(this),
                isModal,
                modalClass = $this.data('modal-class'),
                $modal = $('.' + modalClass),
                $body = $('body'),
                $textarea = $modal.find('textarea');

            $modal.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {

                    // Assign height to text area if there is one in the modal
                    if ($textarea.length != 0) {
                        $textarea.css({
                            'height': $textarea[0].scrollHeight + 'px'
                        });
                    }

                    $body.addClass('fixed');
                }
            });

            // Show and hide Notes from text area fields on view regimen screen.
            if ($body.hasClass('fixed')) {
                isModal = true;
            } else {
                isModal = false;
            }
        });
    }
}
